import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import * as styles from '../InputField/styles.css';
import cn from 'classnames';
import { formatPhone } from '../../utils/formatString'; // бага с дефолтными импортами ES6

var InputMask = require('react-input-mask');

export var PhoneField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var name = _ref.name,
      placeholder = _ref.placeholder,
      invalid = _ref.invalid,
      value = _ref.value,
      onChange = _ref.onChange,
      onKeyDown = _ref.onKeyDown,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      errorMessage = _ref.errorMessage,
      autoFocus = _ref.autoFocus,
      disabled = _ref.disabled,
      autoComplete = _ref.autoComplete;
  var beforeMaskedValueChange = React.useCallback(function (_ref2, _, userInput) {
    var selection = _ref2.selection,
        value = _ref2.value;
    var nextValue = value;
    var nextSelection = selection;
    var rawUserInput = userInput ? userInput.replace(/[\s()a-z-+]+/gi, '') : '';

    if (nextValue.trim() === '+7') {
      nextValue = nextValue.trim();
    }

    if (/\d+/.test(rawUserInput) && rawUserInput.length === 11 && rawUserInput.startsWith('7')) {
      var formatted = formatPhone(rawUserInput);
      return {
        value: formatted,
        selection: {
          start: formatted.length,
          end: formatted.length
        }
      };
    }

    return {
      value: nextValue,
      selection: nextSelection
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['input-group']
  }, /*#__PURE__*/React.createElement(InputMask, {
    inputRef: ref,
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    beforeMaskedValueChange: beforeMaskedValueChange,
    placeholder: placeholder,
    onKeyDown: onKeyDown,
    onFocus: onFocus,
    onBlur: onBlur,
    className: cn(styles['input'], _defineProperty({}, styles['input-invalid'], invalid)),
    type: "tel",
    disabled: disabled,
    mask: "+7 999 999 99 99",
    maskChar: null,
    value: value,
    name: name,
    onChange: onChange
  })), errorMessage && /*#__PURE__*/React.createElement("span", {
    className: styles['error-message']
  }, errorMessage));
});
PhoneField.displayName = 'PhoneField';